<template>
  <div class="container">
    <div class="mwow-top-title">
      <span class="text">体验记录</span>
    </div>
    <div class="header-btns">
      <div class="btn">
        <el-button class="mwow-button-filled success" @click="goCreateSechdule"
          >添加体验</el-button
        >
      </div>
      <div
        class="mwow-button-filled primary"
        @click="clickexport"
        v-debounce="1000"
      >
        导出
      </div>
    </div>
    <el-form
      size="mini"
      :model="searchInfo"
      label-position="left"
      label-width="74px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="快速筛选：" prop="time_tag">
            <el-radio-group
              v-model="searchInfo.time_tag"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="'7'">7天内转化</el-radio-button>
              <el-radio-button :label="'14'">14天内转化</el-radio-button>
              <el-radio-button :label="'30'">30天内转化</el-radio-button>
              <el-radio-button :label="'gt30'">超过30天转化</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="学员搜索：" prop="student_id">
            <el-select
              v-model.number="searchInfo.student_id"
              filterable
              clearable
              placeholder="请选择"
              @clear="handleSearchStudent()"
              :filter-method="
                (queryString) => {
                  handleSearchStudent(queryString);
                }
              "
              @change="handleSearch"
            >
              <el-option
                v-for="item in studentList"
                :key="item.student_id"
                :label="item.name"
                :value="item.student_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="体验时间：" prop="date">
            <common-date-range-selector
              v-model="searchInfo.date"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="handleSearch"
              value-format="yyyy-MM-dd"
            >
            </common-date-range-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出现方式：" prop="appear_id">
            <el-select
              v-model.number="searchInfo.appear_id"
              filterable
              clearable
              placeholder="请选择"
              @change="
                () => {
                  searchInfo.source_channel = '';
                  sourceChannelList = [];
                  handleSearchSource();
                  handleSearch();
                }
              "
            >
              <el-option
                v-for="item in studentAppearLabelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="来源渠道：" prop="source_channel">
            <el-select
              v-model.number="searchInfo.source_channel"
              filterable
              clearable
              placeholder="请选择"
              @change="handleSearch"
              @focus="
                () => {
                  if (!searchInfo.appear_id) {
                    $message({
                      type: 'warning',
                      message: '请先选择出现方式',
                    });
                  }
                }
              "
            >
              <el-option
                v-for="item in sourceChannelList"
                :key="item.source_id"
                :label="item.name"
                :value="item.source_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授课教师:" prop="teacher_id">
            <common-staff-pull-down
              :originId.sync="searchInfo.teacher_id"
              :defaultSelected.sync="searchInfo.teacher_list"
              :originName="searchInfo.teacher_name"
              :jobIds="[1]"
              @change="handleSearch"
            ></common-staff-pull-down>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="转化类型：" prop="student_transform_type">
            <el-radio-group
              v-model="searchInfo.student_transform_type"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">未读学员</el-radio-button>
              <el-radio-button :label="2">已读学员</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="课程类型：" prop="pay_status">
            <el-radio-group
              v-model="searchInfo.course_type"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">一对多</el-radio-button>
              <el-radio-button :label="2">一对一</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="体验课程:" prop="course_id">
            <el-select
              v-model.number="searchInfo.course_id"
              filterable
              clearable
              placeholder="请选择"
              @clear="handleSearchCourse()"
              :filter-method="
                (queryString) => {
                  handleSearchCourse(queryString);
                }
              "
              @change="handleSearch"
            >
              <el-option
                v-for="item in courseList"
                :key="item.course_id"
                :label="item.title"
                :value="item.course_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="班级名称:" prop="class_id">
            <el-select
              v-model.number="searchInfo.class_id"
              filterable
              clearable
              placeholder="请选择"
              @clear="handleSearchClass()"
              :filter-method="
                (queryString) => {
                  handleSearchClass(queryString);
                }
              "
              @change="handleSearch"
            >
              <el-option
                v-for="item in classList"
                :key="item.class_id"
                :label="item.name"
                :value="item.class_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div :style="showFormSearch ? 'display: block;' : 'display: none;'">
        <el-row>
          <el-col :span="8">
            <el-form-item label="课程顾问：" prop="follow_staff_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.follow_staff_id"
                :defaultSelected.sync="searchInfo.follow_staff_list"
                :jobIds="[3]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="体验状态：" prop="experience_status">
              <el-select
                v-model="searchInfo.experience_status"
                multiple
                filterable
                default-first-option
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option label="未体验" key="1" :value="1"> </el-option>
                <el-option label="已体验" key="2" :value="2"> </el-option>
                <el-option label="取消" key="3" :value="3"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="缴费状态：" prop="pay_status">
              <el-radio-group
                v-model="searchInfo.pay_status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">未缴费</el-radio-button>
                <el-radio-button :label="2">已缴费</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="订单号：" prop="order_no">
              <el-input
                v-model="searchInfo.order_no"
                placeholder="请输入订单号"
                @change="handleSearch"
                clearable
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="time-line-switch">
      <div class="btn" @click="showFormSearch = !showFormSearch">
        {{ showFormSearch ? "收起" : "展开" }}
        <span
          :class="showFormSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        ></span>
      </div>
      <div class="btn" @click="resetSearch">
        重置
        <span class="el-icon-refresh-right"></span>
      </div>
    </div>
    <el-table
      class="mwow-table"
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="学员姓名" fixed min-width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.student">
            <div class="mwow-gray" v-if="scope.row.student.is_del === 1">
              {{ scope.row.student.name || "-"
              }}<span class="mwow-tag del-filled large">已删除</span>
            </div>
            <div
              v-else
              class="mwow-green"
              style="cursor: pointer"
              @click="toStudentDetail(scope.row)"
            >
              {{ scope.row.student.name || "-" }}
              <span
                class="mwow-tag success-filled"
                v-if="scope.row.student.status === 2"
                >在读</span
              >
              <span
                class="mwow-tag primary-filled"
                v-if="scope.row.student.status === 1"
                >意向</span
              >
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        label="转化类型"
        prop="student_transform_type"
        width="100"
      >
        <template slot="header">
          <span>
            <span>转化类型</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="200"
            >
              <p>
                体验时的学员身份，未报读过的学员为未读学员，已报读过的学员为已读学员
              </p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </span>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.student_transform_type === 1">未读学员</div>
          <div v-else-if="scope.row.student_transform_type === 2">已读学员</div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="130">
        <template slot-scope="scope">
          <span v-if="scope.row.student">
            {{ "+" + scope.row.student.area_code }}
            {{ scope.row.student.mobile || "-" }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="出现方式" prop="appear_id">
        <template slot-scope="scope">
          {{ handleAppear(scope) }}
        </template>
      </el-table-column>
      <el-table-column label="来源渠道" prop="source_type">
        <template slot-scope="scope">
          {{ scope.row.student_source ? scope.row.student_source.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="授课教师">
        <template slot-scope="scope">
          <span v-if="scope.row.teacher.length !== 0">
            {{
              scope.row.teacher
                .map((item) => {
                  return item.name;
                })
                .join(",")
            }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="课程类型" prop="course.course_type">
        <template slot-scope="scope">
          <div>{{ scope.row.course.course_type === 1 ? "1vN" : "1v1" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="体验课程">
        <template slot-scope="scope">
          <span v-if="scope.row.course">{{
            scope.row.course.title || "-"
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="班级名称">
        <template slot-scope="scope">
          <span v-if="scope.row.class">{{ scope.row.class.name || "-" }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="体验时间"
        prop="date_format"
        width="250"
      ></el-table-column>
      <el-table-column label="课程顾问">
        <template slot-scope="scope">
          <span v-if="scope.row.follow_staff">{{
            scope.row.follow_staff.name || "-"
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="反馈"
        prop="experience_feedback"
        class-name="follow-content"
        width="270"
      >
        <template slot-scope="scope">
          <feedback-dialog
            :lesson-id="scope.row.experience_id"
            :origin-content="scope.row.experience_feedback"
            @change="handleRefresh"
          >
            <span
              v-if="
                scope.row.experience_feedback != null &&
                scope.row.experience_feedback
              "
            >
              <el-popover
                placement="top-start"
                title="反馈"
                width="200"
                trigger="hover"
                :content="scope.row.experience_feedback"
              >
                <span slot="reference" class="mwow-green cu-po">
                  {{ scope.row.experience_feedback }}
                </span>
              </el-popover>
            </span>
            <span v-else>-</span>
          </feedback-dialog>
        </template>
      </el-table-column>
      <el-table-column label="体验状态" prop="experience_status">
        <template slot-scope="scope">
          <span v-if="scope.row.experience_status === 2">已体验</span>
          <span v-else-if="scope.row.experience_status === 1">未体验</span>
          <span v-else-if="scope.row.experience_status === 3">已取消</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="缴费状态" prop="experience_pay_status" width="95">
        <template slot="header">
          <span>缴费状态</span>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.experience_pay_status === 1">未缴费</span>
          <span v-else-if="scope.row.experience_pay_status === 2">已缴费</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="转化天数" prop="transform_day"> </el-table-column>
      <el-table-column label="订单号" prop="order_no" width="200">
        <template slot-scope="scope">
          <div
            class="mwow-green cu-po"
            @click="toOrderDetails(scope.row)"
            v-if="scope.row.order_no"
          >
            {{ scope.row.order_no }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="缴费金额" prop="order_amount">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.order_amount === ""
                ? "-"
                : `${"¥" + scope.row.order_amount}`
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="212">
        <template slot-scope="scope">
          <div class="table-btns">
            <div class="btn">
              <el-button
                class="mwow-button success"
                @click="toCreateSechdule(scope.row)"
                >重新体验</el-button
              >
            </div>
            <div class="btn">
              <feedback-dialog
                :lesson-id="scope.row.experience_id"
                :origin-content="scope.row.experience_feedback"
                @change="handleRefresh"
              >
                <el-button class="mwow-button inter">反馈</el-button>
              </feedback-dialog>
            </div>
            <div class="btn" v-if="scope.row.experience_status === 1">
              <cancel-dialog
                :lesson-id="scope.row.experience_id"
                @change="handleRefresh"
              >
                <el-button class="mwow-button info">取消</el-button>
              </cancel-dialog>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  getSelectCourseList,
  getSelectClassList,
  staffList,
  searchStudent,
} from "@/api/globalSearch";
import {
  getExperienceLessonListApi,
  experienceListExport,
} from "@/api/experienceLesson";
import { PageModule } from "@/store/module/page";
import feedbackDialog from "./feedbackDialog.vue";
import cancelDialog from "./cancelDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import { mixin } from "@/mixin/tabPageInfoMixin";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "experienceLogList",
  components: {
    feedbackDialog,
    cancelDialog,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  mixins: [mixin],
  data() {
    return {
      searchInfo: {
        teacher_id: "",
        teacher_list: [],
        follow_staff_id: "",
        follow_staff_list: [],
        student_transform_type: -1,
      },
      teacherList: [],
      courseList: [],
      sourceChannelList: [],
      classList: [],
      staffList: [],
      studentList: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      showFormSearch: false,
      studentAppearLabelList: [],
    };
  },

  created() {
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
    const self = this;
    self.searchInfo.date = [
      dateFormat("YYYY-mm-dd", new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
      dateFormat("YYYY-mm-dd", new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
    ];
    self.mixinGetPageInfo("experienceRecordSearch");
    if (
      PageModule.latestRoute === "studyDetails" ||
      PageModule.latestRoute === "experienceSechdule"
    ) {
      const cache = PageModule.pageInfo.recruitExperienceList;
      if (cache.page) {
        self.page = cache.page;
      }
      if (cache.search_info) {
        self.searchInfo = cache.search_info;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = self.$route.params;
      if (params.start_date && params.end_date) {
        self.searchInfo.date = [params.start_date, params.end_date];
      }
      if (params.experience_status) {
        self.searchInfo.experience_status = JSON.parse(
          params.experience_status
        );
      }
    } else {
      if (self.$route.query.from === "salary_tab_achievements") {
        const salaryCache = sessionStorage.getItem(
          "salary-achievements-link-to-experience-student-list"
        );
        if (salaryCache) {
          // 来自工资绩效页
          const cache = JSON.parse(salaryCache);
          if (cache.teacher_id && cache.teacher_name) {
            self.searchInfo.teacher_id = cache.teacher_id;
            self.searchInfo.teacher_name = cache.teacher_name; // 给筛选组件设置初始值
          }
          if (cache.lesson_date) {
            self.searchInfo.date = cache.lesson_date;
          }
          if (cache.experience_statu) {
            self.searchInfo.experience_status = [cache.experience_statu];
          }
          sessionStorage.removeItem(
            "salary-achievements-link-to-experience-student-list"
          );
        }
      }
    }
    // 来自体验数
    if (self.$route.query.from === "experience") {
      self.searchInfo.date[0] = self.$route.query.s_time;
      self.searchInfo.date[1] = self.$route.query.e_time;
      if (self.$route.query.c_id) {
        self.searchInfo.follow_staff_id = Number(self.$route.query.c_id);
      }
      if (self.$route.query.s_id) {
        self.searchInfo.teacher_id = Number(self.$route.query.s_id);
      }
      if (self.$route.query.source_id) {
        self.searchInfo.source_channel = Number(self.$route.query.source_id);
        sourceTypeSelectListApi().then((result) => {
          let target = result.data.list.find((s) => {
            return s.source_id === Number(self.$route.query.source_id);
          });
          if (target) {
            this.sourceChannelList = [target];
          }
        });
      }
      if (self.$route.query.course_id) {
        self.searchInfo.course_id =
          Number(self.$route.query.course_id) === 0
            ? ""
            : Number(self.$route.query.course_id);
      }
      if (self.$route.query.a_id) {
        self.searchInfo.appear_id = Number(self.$route.query.a_id);
      }
      if (self.$route.query.val === "finish_count") {
        self.searchInfo.experience_status = [2];
      }
      if (self.$route.query.val === "invited_count") {
        self.searchInfo.experience_status = [1, 2, 3];
      }
      if (self.$route.query.val === "invited_count_1vn") {
        self.searchInfo.experience_status = [1, 2, 3];
        self.searchInfo.course_type = 1;
      }
      if (self.$route.query.val === "invited_count_1v1") {
        self.searchInfo.experience_status = [1, 2, 3];
        self.searchInfo.course_type = 2;
      }
      if (
        self.$route.query.val === "transform_count" ||
        self.$route.query.val === "transform_amount"
      ) {
        self.searchInfo.pay_status = 2;
      }
      if (self.$route.query.val === "transform_amount_1vn") {
        self.searchInfo.course_type = 1;
        self.searchInfo.pay_status = 2;
      }
      if (self.$route.query.val === "transform_amount_1v1") {
        self.searchInfo.course_type = 2;
        self.searchInfo.pay_status = 2;
      }
      // 体验转化数
      if (self.$route.query.val === "all") {
        self.searchInfo.experience_status = [2];
        self.searchInfo.pay_status = 2;
      }
      if (self.$route.query.pay_type) {
        self.searchInfo.pay_status = Number(self.$route.query.pay_type);
      }
    }
    self.getList({
      page: self.page,
      page_size: self.pageSize,
    });
    searchStudent({
      page: 1,
      page_size: 50,
      status: [1, 2],
    }).then((result) => {
      if (result.error_code === 0) {
        self.studentList = result.data.list;
        getSelectCourseList({
          page: 1,
          page_size: 100,
        }).then((res) => {
          self.courseList = res.data.list;
        });
        getSelectClassList({
          page: 1,
          page_size: 50,
        }).then((res) => {
          self.classList = res.data.list;
        });
        staffList({
          page: 1,
          page_size: 50,
          job_ids: [3],
        }).then((res) => {
          // 处理来自体验数据且没有这个课程顾问的情况下添加一条课程顾问;
          if (self.$route.query.experience_course) {
            let hasStaffList = false;
            res.data.list.map((it) => {
              if (
                self.$route.query.from === "experience" &&
                it.staff_id !== Number(self.$route.query.c_id)
              ) {
                hasStaffList = true;
              } else {
                hasStaffList = false;
              }
            });
            if (hasStaffList) {
              res.data.list.unshift({
                name: self.$route.query.c_name,
                staff_id: Number(self.$route.query.c_id),
              });
            }
          }
          self.staffList = res.data.list;
        });
        staffList({
          page: 1,
          page_size: 50,
          job_ids: [1],
        }).then((res) => {
          self.teacherList = res.data.list;
        });
      }
    });
    this.handleSearchSource();
  },
  methods: {
    handleSearchSource() {
      if (!this.searchInfo.appear_id) {
        return false;
      }
      sourceTypeSelectListApi({ appear_id: this.searchInfo.appear_id }).then(
        (result) => {
          this.sourceChannelList = result.data.list;
        }
      );
    },
    handleAppear(scope) {
      let target = this.studentAppearLabelList.find((item) => {
        return scope.row.appear_id === item.id;
      });
      if (target) {
        return target.name;
      } else {
        return "-";
      }
    },
    resetSearch() {
      this.searchInfo = {
        experience_status: [],
        time_tag: -1,
        pay_status: -1,
        course_type: -1,
      };
      this.handleSearch();
      this.mixinSavePageInfo("experienceRecordSearch");
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
      this.mixinSavePageInfo("experienceRecordSearch");
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v,
        status: [1, 2],
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
    },
    handleSearchCourse(v) {
      if (!v) {
        return false;
      }
      getSelectCourseList({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        this.courseList = res.data.list;
      });
    },
    handleSearchClass(v) {
      getSelectClassList({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        this.classList = res.data.list;
      });
    },
    clickexport() {
      const data = {};
      if (this.searchInfo.student_id !== "") {
        data.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.teacher_id !== "") {
        data.teacher_id = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.course_id !== "") {
        data.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.class_id !== "") {
        data.class_id = this.searchInfo.class_id;
      }
      if (this.searchInfo.follow_staff_id !== "") {
        data.follow_staff_id = this.searchInfo.follow_staff_id;
      }
      if (this.searchInfo.date && this.searchInfo.date.length === 2) {
        data.start_date = this.searchInfo.date[0];
        data.end_date = this.searchInfo.date[1];
      } else {
        data.start_date = dateFormat("YYYY-mm-dd", new Date());
        data.end_date = dateFormat("YYYY-mm-dd", new Date());
      }
      if (this.searchInfo.experience_status.length > 0) {
        data.experience_status_arr = this.searchInfo.experience_status;
      }
      if (this.searchInfo.pay_status >= 0) {
        data.pay_status = this.searchInfo.pay_status;
      }
      if (this.searchInfo.source_channel !== "") {
        data.source_type = this.searchInfo.source_channel;
      }
      if (this.searchInfo.appear_id !== "") {
        data.appear_id = this.searchInfo.appear_id;
      }
      if (this.searchInfo.time_tag != -1) {
        data.time_tag = this.searchInfo.time_tag;
      }
      if (this.searchInfo.order_no !== "") {
        data.order_no = this.searchInfo.order_no;
      }
      if (this.searchInfo.student_transform_type > 0) {
        data.student_transform_type = this.searchInfo.student_transform_type;
      }
      experienceListExport(data).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        start_date: "",
        end_date: "",
      };
      if (this.searchInfo.student_id !== "") {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.teacher_id !== "") {
        option.teacher_id = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.course_id !== "") {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.class_id !== "") {
        option.class_id = this.searchInfo.class_id;
      }
      if (this.searchInfo.follow_staff_id !== "") {
        option.follow_staff_id = this.searchInfo.follow_staff_id;
      }
      if (this.searchInfo.date && this.searchInfo.date.length === 2) {
        option.start_date = this.searchInfo.date[0];
        option.end_date = this.searchInfo.date[1];
      }
      // else {
      //   option.start_date = dateFormat("YYYY-mm-dd", new Date());
      //   option.end_date = dateFormat("YYYY-mm-dd", new Date());
      // }
      if (this.searchInfo.experience_status.length > 0) {
        option.experience_status_arr = this.searchInfo.experience_status;
      }
      if (this.searchInfo.pay_status >= 0) {
        option.pay_status = this.searchInfo.pay_status;
      }
      if (this.searchInfo.source_channel !== "") {
        option.source_type = this.searchInfo.source_channel;
      }
      if (this.searchInfo.appear_id !== "") {
        option.appear_id = this.searchInfo.appear_id;
      }
      if (this.searchInfo.time_tag != -1) {
        option.time_tag = this.searchInfo.time_tag;
      }
      if (this.searchInfo.order_no !== "") {
        option.order_no = this.searchInfo.order_no;
      }
      if (this.searchInfo.course_type > 0) {
        option.course_type = this.searchInfo.course_type;
      }
      if (this.searchInfo.student_transform_type > 0) {
        option.student_transform_type = this.searchInfo.student_transform_type;
      }
      getExperienceLessonListApi(option).then((res) => {
        this.page = res.data.page;
        this.total = res.data.total;
        res.data.list.map((item) => {
          item.date_format = `${item.experience_date} （周${
            ["日", "一", "二", "三", "四", "五", "六"][item.experience_week]
          }） ${item.experience_start_time.slice(
            0,
            5
          )} ~ ${item.experience_end_time.slice(0, 5)}`;
          if (item.transform_day === 0) {
            item.transform_day = "-";
          }
        });
        this.tableData = res.data.list;
      });
    },
    toStudentDetail(row) {
      this.mixinSavePageInfo("experienceRecordSearch");
      this.$router.push({
        name: "studyDetails",
        query: {
          id: row.student.student_id,
        },
      });
    },
    toCreateSechdule(row) {
      if (row.student) {
        PageModule.SET_PAGE_INFO({
          name: "recruitExperienceList",
          key: "selected_student",
          value: row.student,
        });
      }
      PageModule.SET_PAGE_INFO({
        name: "recruitExperienceList",
        key: "search_info",
        value: { ...this.searchInfo },
      });
      this.$router.push({
        name: "experienceSechdule",
        query: {
          sid: row.student.student_id,
          sname: row.student.name,
        },
      });
    },
    goCreateSechdule() {
      this.$router.push({
        name: "experienceSechdule",
        query: {
          show_follow_dialog_id: "99",
        },
      });
      this.mixinSavePageInfo("experienceRecordSearch");
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      this.mixinSavePageInfo("experienceRecordSearch");
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    // 去订单详情
    toOrderDetails(it) {
      this.mixinSavePageInfo("experienceRecordSearch");
      if (it.order_amount !== "") {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            sid: it.student.student_id,
            id: it.order_id,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.header-btns {
  margin-bottom: 12px;
  .btn {
    margin-right: 20px;
    display: inline-block;
  }
}
.table-btns {
  text-align: left;
  .btn {
    display: inline-block;
    .el-button {
      margin: 0 4px;
    }
  }
}
/deep/ .el-form {
  .el-form-item {
    margin-right: 58px;
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}
.time-line-switch {
  position: absolute;
  top: 152px;
  right: 2px;
  .btn {
    padding: 8px;
    font-size: 12px;
    cursor: pointer;
    color: #5c5d5e;
    margin-bottom: 15px;
    span {
      font-size: 14px;
      color: #c0c4cc;
      margin-left: 4px;
    }
  }
}
/deep/ .follow-content {
  .cell {
    width: 21em;
    overflow: hidden;
    text-overflow: ellipsis; //文本溢出显示省略号
    white-space: nowrap; //文本不会换行
  }
}
</style>
